import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './MRPTab.module.css';
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import classes from "./MRPTab.module.css";
import DateBar from "../../../components/common/DateBar/DateBar";
import NotificationBell from "../../../components/common/NotificationBell/NotificationBell";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";

const MRPTab = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.loginData.value);

    const [mpsData, setMpsData] = useState([]);
    const [newMpsEntry, setNewMpsEntry] = useState({
        productCode: '',
        productName: '',
        productionQuantity: '',
        scheduledProductionDates: '',
        productionLeadTime: '',
        productionCapacity: '',
    });


    const [bomData, setBomData] = useState([]);
    const [newBomEntry, setNewBomEntry] = useState({
        bomCode: '',
        productCode: '',
        productName: '',
        componentCode: '',
        componentName: '',
        quantityPerAssembly: '',
        unitOfMeasure: '',
        bomVersion: '',
        effectiveDate: '',
    });

    const [inventoryStatusData, setInventoryStatusData] = useState([]);
    const [newInventoryStatusEntry, setNewInventoryStatusEntry] = useState({
        itemCode: '',
        itemName: '',
        stockQuantity: '',
        reservedQuantity: '',
        availableQuantity: '',
        reorderLevel: '',
        safetyStockLevel: '',
    });

    const [mrpCalculationsData, setMrpCalculationsData] = useState([]);
    const [newMrpCalculationsEntry, setNewMrpCalculationsEntry] = useState({
        netRequirements: '',
        plannedOrders: '',
        orderQuantity: '',
        orderReleaseDate: '',
        orderDueDate: '',
        leadTimeOffset: '',
    });

    const [capacityPlanningData, setCapacityPlanningData] = useState([]);
    const [newCapacityPlanningEntry, setNewCapacityPlanningEntry] = useState({
        workCenterCode: '',
        workCenterName: '',
        capacityUtilization: '',
        availableCapacity: '',
        requiredCapacity: '',
        loadPercentage: '',
    });

    const [procurementPlanningData, setProcurementPlanningData] = useState([]);
    const [newProcurementPlanningEntry, setNewProcurementPlanningEntry] = useState({
        supplierCode: '',
        supplierName: '',
        purchaseOrderCode: '',
        orderQuantity: '',
        expectedDeliveryDate: '',
        purchaseLeadTime: '',
    });

    const [workOrderData, setWorkOrderData] = useState([]);
    const [newWorkOrderEntry, setNewWorkOrderEntry] = useState({
        workOrderCode: '',
        productCode: '',
        quantityToProduce: '',
        status: '',
        startDate: '',
        endDate: '',
        labourHours: '',
    });

    const [demandForecastingData, setDemandForecastingData] = useState([]);
    const [newDemandForecastingEntry, setNewDemandForecastingEntry] = useState({
        productCode: '',
        forecastedQuantity: '',
        forecastPeriod: '',
        historicalSalesData: '',
    });

    const [lotTrackingData, setLotTrackingData] = useState([]);
    const [newLotTrackingEntry, setNewLotTrackingEntry] = useState({
        lotNumber: '',
        serialNumber: '',
        itemCode: '',
        productionDate: '',
        expiryDate: '',
    });

    const handleInputChange = (e, setState, state) => {
        const { name, value } = e.target;
        setState({
            ...state,
            [name]: value,
        });
    };

    return (

        <div className={classes.users_tab_wrapper}>
            <div className={classes.users_topHeader}>
                <div className={`${classes.lhs} flex`}>
                    <HeaderTitle titleText="Material Requirements Planning (MRP)" customclass={classes.dashHead} />
                </div>
            </div>

            <div className={classes.tabsScreens}>
                <div className={classes.infoSection}>
                    <div className={classes.mrpFormWrapper}>
                        <form>
                            <h3 className={classes.subTitle}>Master Production Schedule (MPS)</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Product CODE"
                                    value={newMpsEntry.productCode}
                                    onChange={(e) => handleInputChange(e, setNewMpsEntry, newMpsEntry)}
                                    name="productCode"
                                />
                                <DTextInput
                                    label="Product Name"
                                    value={newMpsEntry.productName}
                                    onChange={(e) => handleInputChange(e, setNewMpsEntry, newMpsEntry)}
                                    name="productName"
                                />
                                <DTextInput
                                    label="Production Quantity"
                                    value={newMpsEntry.productionQuantity}
                                    onChange={(e) => handleInputChange(e, setNewMpsEntry, newMpsEntry)}
                                    name="productionQuantity"
                                />
                                <DTextInput
                                    label="Scheduled Production Dates"
                                    value={newMpsEntry.scheduledProductionDates}
                                    onChange={(e) => handleInputChange(e, setNewMpsEntry, newMpsEntry)}
                                    name="scheduledProductionDates"
                                />
                                <DTextInput
                                    label="Production Lead Time"
                                    value={newMpsEntry.productionLeadTime}
                                    onChange={(e) => handleInputChange(e, setNewMpsEntry, newMpsEntry)}
                                    name="productionLeadTime"
                                />
                                <DTextInput
                                    label="Production Capacity"
                                    value={newMpsEntry.productionCapacity}
                                    onChange={(e) => handleInputChange(e, setNewMpsEntry, newMpsEntry)}
                                    name="productionCapacity"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Bill of Materials (BOM)</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="BOM CODE"
                                    value={newBomEntry.bomCode}
                                    onChange={(e) => handleInputChange(e, setNewBomEntry, newBomEntry)}
                                    name="bomCode"
                                />
                                <DTextInput
                                    label="Product CODE"
                                    value={newBomEntry.productCode}
                                    onChange={(e) => handleInputChange(e, setNewBomEntry, newBomEntry)}
                                    name="productCode"
                                />
                                <DTextInput
                                    label="Product Name"
                                    value={newBomEntry.productName}
                                    onChange={(e) => handleInputChange(e, setNewBomEntry, newBomEntry)}
                                    name="productName"
                                />
                                <DTextInput
                                    label="Component CODE"
                                    value={newBomEntry.componentCode}
                                    onChange={(e) => handleInputChange(e, setNewBomEntry, newBomEntry)}
                                    name="componentCode"
                                />
                                <DTextInput
                                    label="Component Name"
                                    value={newBomEntry.componentName}
                                    onChange={(e) => handleInputChange(e, setNewBomEntry, newBomEntry)}
                                    name="componentName"
                                />
                                <DTextInput
                                    label="Quantity per Assembly"
                                    value={newBomEntry.quantityPerAssembly}
                                    onChange={(e) => handleInputChange(e, setNewBomEntry, newBomEntry)}
                                    name="quantityPerAssembly"
                                />
                                <DTextInput
                                    label="Unit of Measure"
                                    value={newBomEntry.unitOfMeasure}
                                    onChange={(e) => handleInputChange(e, setNewBomEntry, newBomEntry)}
                                    name="unitOfMeasure"
                                />
                                <DTextInput
                                    label="BOM Version"
                                    value={newBomEntry.bomVersion}
                                    onChange={(e) => handleInputChange(e, setNewBomEntry, newBomEntry)}
                                    name="bomVersion"
                                />
                                <DTextInput
                                    label="Effective Date"
                                    value={newBomEntry.effectiveDate}
                                    onChange={(e) => handleInputChange(e, setNewBomEntry, newBomEntry)}
                                    name="effectiveDate"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Inventory Status</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Item CODE"
                                    value={newInventoryStatusEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewInventoryStatusEntry, newInventoryStatusEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Item Name"
                                    value={newInventoryStatusEntry.itemName}
                                    onChange={(e) => handleInputChange(e, setNewInventoryStatusEntry, newInventoryStatusEntry)}
                                    name="itemName"
                                />
                                <DTextInput
                                    label="Stock Quantity"
                                    value={newInventoryStatusEntry.stockQuantity}
                                    onChange={(e) => handleInputChange(e, setNewInventoryStatusEntry, newInventoryStatusEntry)}
                                    name="stockQuantity"
                                />
                                <DTextInput
                                    label="Reserved Quantity"
                                    value={newInventoryStatusEntry.reservedQuantity}
                                    onChange={(e) => handleInputChange(e, setNewInventoryStatusEntry, newInventoryStatusEntry)}
                                    name="reservedQuantity"
                                />
                                <DTextInput
                                    label="Available Quantity"
                                    value={newInventoryStatusEntry.availableQuantity}
                                    onChange={(e) => handleInputChange(e, setNewInventoryStatusEntry, newInventoryStatusEntry)}
                                    name="availableQuantity"
                                />
                                <DTextInput
                                    label="Reorder Level"
                                    value={newInventoryStatusEntry.reorderLevel}
                                    onChange={(e) => handleInputChange(e, setNewInventoryStatusEntry, newInventoryStatusEntry)}
                                    name="reorderLevel"
                                />
                                <DTextInput
                                    label="Safety Stock Level"
                                    value={newInventoryStatusEntry.safetyStockLevel}
                                    onChange={(e) => handleInputChange(e, setNewInventoryStatusEntry, newInventoryStatusEntry)}
                                    name="safetyStockLevel"
                                />
                            </div>

                            <h3 className={classes.subTitle}>MRP Calculations</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Net Requirements"
                                    value={newMrpCalculationsEntry.netRequirements}
                                    onChange={(e) => handleInputChange(e, setNewMrpCalculationsEntry, newMrpCalculationsEntry)}
                                    name="netRequirements"
                                />
                                <DTextInput
                                    label="Planned Orders"
                                    value={newMrpCalculationsEntry.plannedOrders}
                                    onChange={(e) => handleInputChange(e, setNewMrpCalculationsEntry, newMrpCalculationsEntry)}
                                    name="plannedOrders"
                                />
                                <DTextInput
                                    label="Order Quantity"
                                    value={newMrpCalculationsEntry.orderQuantity}
                                    onChange={(e) => handleInputChange(e, setNewMrpCalculationsEntry, newMrpCalculationsEntry)}
                                    name="orderQuantity"
                                />
                                <DTextInput
                                    label="Order Release Date"
                                    value={newMrpCalculationsEntry.orderReleaseDate}
                                    onChange={(e) => handleInputChange(e, setNewMrpCalculationsEntry, newMrpCalculationsEntry)}
                                    name="orderReleaseDate"
                                />
                                <DTextInput
                                    label="Order Due Date"
                                    value={newMrpCalculationsEntry.orderDueDate}
                                    onChange={(e) => handleInputChange(e, setNewMrpCalculationsEntry, newMrpCalculationsEntry)}
                                    name="orderDueDate"
                                />
                                <DTextInput
                                    label="Lead Time Offset"
                                    value={newMrpCalculationsEntry.leadTimeOffset}
                                    onChange={(e) => handleInputChange(e, setNewMrpCalculationsEntry, newMrpCalculationsEntry)}
                                    name="leadTimeOffset"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Capacity Planning</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Work Center CODE"
                                    value={newCapacityPlanningEntry.workCenterCode}
                                    onChange={(e) => handleInputChange(e, setNewCapacityPlanningEntry, newCapacityPlanningEntry)}
                                    name="workCenterCode"
                                />
                                <DTextInput
                                    label="Work Center Name"
                                    value={newCapacityPlanningEntry.workCenterName}
                                    onChange={(e) => handleInputChange(e, setNewCapacityPlanningEntry, newCapacityPlanningEntry)}
                                    name="workCenterName"
                                />
                                <DTextInput
                                    label="Capacity Utilization"
                                    value={newCapacityPlanningEntry.capacityUtilization}
                                    onChange={(e) => handleInputChange(e, setNewCapacityPlanningEntry, newCapacityPlanningEntry)}
                                    name="capacityUtilization"
                                />
                                <DTextInput
                                    label="Available Capacity"
                                    value={newCapacityPlanningEntry.availableCapacity}
                                    onChange={(e) => handleInputChange(e, setNewCapacityPlanningEntry, newCapacityPlanningEntry)}
                                    name="availableCapacity"
                                />
                                <DTextInput
                                    label="Required Capacity"
                                    value={newCapacityPlanningEntry.requiredCapacity}
                                    onChange={(e) => handleInputChange(e, setNewCapacityPlanningEntry, newCapacityPlanningEntry)}
                                    name="requiredCapacity"
                                />
                                <DTextInput
                                    label="Load Percentage"
                                    value={newCapacityPlanningEntry.loadPercentage}
                                    onChange={(e) => handleInputChange(e, setNewCapacityPlanningEntry, newCapacityPlanningEntry)}
                                    name="loadPercentage"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Procurement Planning</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Supplier CODE"
                                    value={newProcurementPlanningEntry.supplierCode}
                                    onChange={(e) => handleInputChange(e, setNewProcurementPlanningEntry, newProcurementPlanningEntry)}
                                    name="supplierCode"
                                />
                                <DTextInput
                                    label="Supplier Name"
                                    value={newProcurementPlanningEntry.supplierName}
                                    onChange={(e) => handleInputChange(e, setNewProcurementPlanningEntry, newProcurementPlanningEntry)}
                                    name="supplierName"
                                />
                                <DTextInput
                                    label="Purchase Order CODE"
                                    value={newProcurementPlanningEntry.purchaseOrderCode}
                                    onChange={(e) => handleInputChange(e, setNewProcurementPlanningEntry, newProcurementPlanningEntry)}
                                    name="purchaseOrderCode"
                                />
                                <DTextInput
                                    label="Order Quantity"
                                    value={newProcurementPlanningEntry.orderQuantity}
                                    onChange={(e) => handleInputChange(e, setNewProcurementPlanningEntry, newProcurementPlanningEntry)}
                                    name="orderQuantity"
                                />
                                <DTextInput
                                    label="Expected Expected Delivery Date"
                                    value={newProcurementPlanningEntry.expectedDeliveryDate}
                                    onChange={(e) => handleInputChange(e, setNewProcurementPlanningEntry, newProcurementPlanningEntry)}
                                    name="expectedDeliveryDate"
                                />
                                <DTextInput
                                    label="Purchase Lead Time"
                                    value={newProcurementPlanningEntry.purchaseLeadTime}
                                    onChange={(e) => handleInputChange(e, setNewProcurementPlanningEntry, newProcurementPlanningEntry)}
                                    name="purchaseLeadTime"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Work Order Management</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Work Order CODE"
                                    value={newWorkOrderEntry.workOrderCode}
                                    onChange={(e) => handleInputChange(e, setNewWorkOrderEntry, newWorkOrderEntry)}
                                    name="workOrderCode"
                                />
                                <DTextInput
                                    label="Product CODE"
                                    value={newWorkOrderEntry.productCode}
                                    onChange={(e) => handleInputChange(e, setNewWorkOrderEntry, newWorkOrderEntry)}
                                    name="productCode"
                                />
                                <DTextInput
                                    label="Quantity to Produce"
                                    value={newWorkOrderEntry.quantityToProduce}
                                    onChange={(e) => handleInputChange(e, setNewWorkOrderEntry, newWorkOrderEntry)}
                                    name="quantityToProduce"
                                />
                                <DTextInput
                                    label="Status"
                                    value={newWorkOrderEntry.status}
                                    onChange={(e) => handleInputChange(e, setNewWorkOrderEntry, newWorkOrderEntry)}
                                    name="status"
                                />
                                <DTextInput
                                    label="Start Date"
                                    value={newWorkOrderEntry.startDate}
                                    onChange={(e) => handleInputChange(e, setNewWorkOrderEntry, newWorkOrderEntry)}
                                    name="startDate"
                                />
                                <DTextInput
                                    label="End Date"
                                    value={newWorkOrderEntry.endDate}
                                    onChange={(e) => handleInputChange(e, setNewWorkOrderEntry, newWorkOrderEntry)}
                                    name="endDate"
                                />
                                <DTextInput
                                    label="Labour Hours"
                                    value={newWorkOrderEntry.labourHours}
                                    onChange={(e) => handleInputChange(e, setNewWorkOrderEntry, newWorkOrderEntry)}
                                    name="labourHours"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Demand Forecasting</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Product CODE"
                                    value={newDemandForecastingEntry.productCode}
                                    onChange={(e) => handleInputChange(e, setNewDemandForecastingEntry, newDemandForecastingEntry)}
                                    name="productCode"
                                />
                                <DTextInput
                                    label="Forecasted Quantity"
                                    value={newDemandForecastingEntry.forecastedQuantity}
                                    onChange={(e) => handleInputChange(e, setNewDemandForecastingEntry, newDemandForecastingEntry)}
                                    name="forecastedQuantity"
                                />
                                <DTextInput
                                    label="Forecast Period"
                                    value={newDemandForecastingEntry.forecastPeriod}
                                    onChange={(e) => handleInputChange(e, setNewDemandForecastingEntry, newDemandForecastingEntry)}
                                    name="forecastPeriod"
                                />
                                <DTextInput
                                    label="Historical Sales Data"
                                    value={newDemandForecastingEntry.historicalSalesData}
                                    onChange={(e) => handleInputChange(e, setNewDemandForecastingEntry, newDemandForecastingEntry)}
                                    name="historicalSalesData"
                                />
                            </div>

                            <h3 className={classes.subTitle}>Lot Tracking and Traceability</h3>
                            <div className={`${classes.mrpForm} ${classes.borderBottom}`}>
                                <DTextInput
                                    label="Lot Number"
                                    value={newLotTrackingEntry.lotNumber}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="lotNumber"
                                />
                                <DTextInput
                                    label="Serial Number"
                                    value={newLotTrackingEntry.serialNumber}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="serialNumber"
                                />
                                <DTextInput
                                    label="Item Code"
                                    value={newLotTrackingEntry.itemCode}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="itemCode"
                                />
                                <DTextInput
                                    label="Production Date"
                                    value={newLotTrackingEntry.productionDate}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="productionDate"
                                />
                                <DTextInput
                                    label="Expiry Date"
                                    value={newLotTrackingEntry.expiryDate}
                                    onChange={(e) => handleInputChange(e, setNewLotTrackingEntry, newLotTrackingEntry)}
                                    name="expiryDate"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MRPTab;